import React from "react"

import { Grid, Typography } from "@material-ui/core"

import Breadcrumb from "@/components/BreadcrumbNew"
import useStyles from "@/pages/Admin/TrackableLinks/CreateNewTrackableLink/styles"
import CreateNewTrackableLinkForm from "@/pages/Admin/TrackableLinks/CreateNewTrackableLink/CreateNewTrackableLinkForm"

const CreateNewTrackableLink: React.FC = () => {
	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<Breadcrumb
					data={[
						{ name: "Links rastreáveis", pathname: "/admin/tools/trackable-links" },
						{ name: "Novo", pathname: "/admin/tools/trackable-links/create" }
					]}
				/>
			</Grid>

			<Grid item>
				<Grid container direction="column" spacing={4}>
					<Grid item>
						<Typography
							variant="h5"
							className={classes.titleText}
						>
							Novo link
						</Typography>
					</Grid>

					<Grid item>
						<CreateNewTrackableLinkForm />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default CreateNewTrackableLink
